import { GetEmployeeDetailsResponseType } from "../../../types";
import InfoItem from "../../common/InfoItem";

type Props = {
  data?: GetEmployeeDetailsResponseType;
};

export default function EmergencyInfo({ data }: Props) {
  return (
    <ul>
      <InfoItem title="Name">
        {data?.data?.employee?.member?.emergency_contract_person_name}
      </InfoItem>
      <InfoItem title="Mobile Number">
        {data?.data?.employee?.member?.emergency_contract_person_number}
      </InfoItem>
      <InfoItem title="Relationship">
        {data?.data?.employee?.member?.emergency_contract_person_relationship}
      </InfoItem>
      {/* {data?.data?.employee?.status !== "invited" && (
        <EditButtonEmployee type="Emergency" />
      )} */}
    </ul>
  );
}
